<template>
  <b-container fluid style="margin-top:20px;">
      <b-button type="button" @click="showFolderModal" variant="primary" style="margin-bottom:19px;">add folder</b-button>
      <b-button type="button" @click="showDeleteFolderModal" variant="secondary" style="margin-bottom:19px;" class="ml-2"
                v-if="!this.isLoading && !this.hasChildFolders && isAdminOrBucketAdmin()
                && (!this.files || this.files.length === 0)">delete folder</b-button>
      <span class="float-right">
          <b-button type="button" @click="showTagSearchModal" variant="primary" style="margin-bottom:19px;"
                    v-if="permissions.viewTag && !tagsLoading">
              search tags
          </b-button>
          <b-button v-if="permissions.delete" type="button" @click="showMassDeleteModal" variant="primary" class="ml-2"
                    style="margin-bottom:19px;">
              delete <span v-if="selected.length===0"> all</span><span v-if="selected.length > 0"> selected</span>
          </b-button>
          <b-dropdown :text="selected.length > 0 ? 'download selected' : 'download all'" variant="primary"
                      style="margin-bottom:19px;" class="ml-2" v-if="permissions.download">
              <b-dropdown-item @click="downloadFolderFiles">
                  separately
              </b-dropdown-item>
              <b-dropdown-item @click="downloadFolderFilesZip">
                  as zip
              </b-dropdown-item>
            </b-dropdown>
      </span>
    <b-row>
    <splitpanes class="default-theme" >
     <pane>
         <tree ref="folderTree" 
                :data="folders"  
                :options="treeOptions"
                 @node:selected="getFolderFileList"/>

      </pane>
      <pane v-if="permissions.list">
        <strong>Folder:</strong> {{ currentFolder }}
        <b-table hover small responsive show-empty
          :fields="fields"
          :items="files"
          :busy="isLoading"
          selectable
          @row-selected="onRowSelected"
          id="fileTable"
        >
            <template v-slot:cell(select)="{ rowSelected }">
                <b-form-checkbox disabled v-model="rowSelected" aria-label="{rowSelected ? 'Selected' : 'Not Selected'}"
                                 class="text-center" size="lg"/>
            </template>

          <template v-slot:cell(actions)="row" style="min-height: 20em">
            <b-dropdown text="actions" variant="primary" size="sm" style="margin-right:8px;">
              <b-dropdown-item @click="downloadEvent(row.item.filename)" :href="row.item.url" target="_attach"
                v-if="permissions.download">download</b-dropdown-item>
              <b-dropdown-item @click="showDeleteModal(row.item)"
                v-if="permissions.delete">delete</b-dropdown-item>
              <b-dropdown-item @click="showTagModal(row.item)"
                v-if="permissions.tag && !tagsLoading">update tags</b-dropdown-item>
            </b-dropdown>

              
              <b-button size="sm" @click="editTags(row.item)" class="mr-1" variant="primary" style="display: none;">
                labels
              </b-button>
              
              <b-button size="sm" @click="startTranscribeJob(row.item)" class="mr-1" variant="primary"
                v-if="(bucketType === '02' && row.item.isAudio)">
                transcribe...
              </b-button>

          

          </template>
              
          <template v-slot:empty="scope">
              <p>No files found.</p>
          </template>

          <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
              <strong>Loading, Please Wait...</strong>
          </div>  
        </b-table>
      </pane>
      </splitpanes>
    </b-row>

    <b-modal id="modal-tags" hide-header hide-footer>
      <h2>Edit File Tags</h2>
      <hr/>
      <form ref="form" @submit.prevent="saveTags">
          <b-button @click="addTag" class="mb-3" variant="outline-primary">add new tag</b-button>
            <b-table-simple id="tagTbl" hover small caption-top responsive>
                <b-thead>
                    <b-tr>
                        <b-th>Tag Name</b-th>
                        <b-th>Tag Value</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(item, index) in selectedFile.tags" :key="index">
                        <b-td>
                            <b-form-input :validator="$v.selectedFile.tags.$each[index].key" v-model="item.key"
                                          :aria-label="'tag '+index+' key'"/>
                        </b-td>
                        <b-td>
                            <b-form-input :validator="$v.selectedFile.tags.$each[index].value"  v-model="item.value"
                                          :aria-label="'tag '+index+' value'"/>
                        </b-td>
                        <b-td><b-button @click="removeTag(index)" variant="danger">remove</b-button></b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>

          <b-button @click="closeTagModal" style="margin-right:15px;">Cancel</b-button>
          <b-button type="submit" variant="primary" :disabled="$v.selectedFile.tags.$invalid">Save</b-button>
        </form>
    </b-modal>

    <b-modal size="lg" id="modal-tags-search" hide-header hide-footer>
        <h2>Search File Tags</h2>
        <hr/>
        <form ref="form" @submit.prevent="searchTags">
            Search for files with tags where
            <b-row>
                <b-col cols="5">
                    <b-form-group label="Tag Name:" label-for="key-search-input">
                        <b-form-select v-model="search.key" multiple :options="keyOpts"
                                       id="key-search-input"></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="2">
                    <b-form-group label="and/or:" label-for="bool-search-input">
                        <b-form-select v-model="search.isAnd" id="bool-search-input">
                            <b-form-select-option :value="true" selected>AND</b-form-select-option>
                            <b-form-select-option :value="false">OR</b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="5">
                    <b-form-group label="Tag Value:" label-for="value-search-input">
                        <b-form-select v-model="search.value" multiple :options="valueOpts"
                                       id="value-search-input"></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-button @click="closeTagSearchModal" style="margin-right:15px;">Cancel</b-button>
            <b-button @click="clearSearch" style="margin-right:15px;">Clear</b-button>
            <b-button type="submit" variant="primary">Search</b-button>
        </form>
    </b-modal>

    <b-modal id="prepare-job-modal" hide-header hide-footer>
      <h2>Prepare Transcribe Request</h2>
      <hr/>
      
      <b-form-group label="Type of Transcription Job:">
        <b-form-radio v-model="jobType" name="jobtype-radios" value="01">Standard</b-form-radio>
        <b-form-radio v-model="jobType" name="some-jobtype-radios" value="02">Medical</b-form-radio>
      </b-form-group>

      <div v-if="jobType === '01'">
        <b-form-group label="Language:" label-for="input-1">
          <b-form-select v-model="language" :options="languageOpts" id="input-1"></b-form-select>
        </b-form-group>
      </div>

      <div v-if="jobType === '02'">
        <b-form-group label="Type of Transcription Job:">
          <b-form-radio v-model="medicalAudioType" name="medaudiotype-radios" value="01">Conversation</b-form-radio>
          <b-form-radio v-model="medicalAudioType" name="medaudiotype-radios" value="02">Dictation</b-form-radio>
        </b-form-group>
      </div>

      <b-form-checkbox v-model="audioIdentification" name="audioIdentification-button" switch
        style="margin-bottom:10px;">
        Audio Identification
      </b-form-checkbox>

      <div v-if="audioIdentification">
        <b-form-group label="Audio Identification Type:">
          <b-form-radio v-model="audioIdentificationType" name="aitype-radios" value="01">Channel Identification</b-form-radio>
          <b-form-radio v-model="audioIdentificationType" name="aitype-radios" value="02">Speaker Identification</b-form-radio>
        </b-form-group>

        <b-form-group label="Maximum number of speakers:" label-for="input-2"
          v-if="audioIdentificationType === '02'">
          <b-form-input type="number" v-model="maxSpeakerNbr" id="input-2"></b-form-input>
        </b-form-group>
      </div>

      
      <form ref="form" @submit.prevent="submitJob" style="margin-top:20px;">
          <b-button @click="closeJobModal" style="margin-right:15px;">Cancel</b-button>
          <b-button type="submit" variant="primary">Submit Job</b-button>
        </form>
    </b-modal>

     <b-modal id="folder-modal" hide-header hide-footer>
         <h2>Add Folder</h2>
         <hr/>
         <form ref="form" @submit.prevent="saveFolder">
             <b-form-group label="Folder Name:" label-for="input-1">
                 <b-form-input type="text" v-model="folderName" id="input-1"></b-form-input>
             </b-form-group>
             <b-button @click="closeFolderModal" style="margin-right:15px;">Cancel</b-button>
             <b-button type="submit" variant="primary">Save</b-button>
         </form>
     </b-modal>

      <b-modal id="folder-delete-modal" hide-header hide-footer>
          <h2>Delete Folder</h2>
          <hr/>
          <form ref="form" @submit.prevent="deleteFolder">
              You are about to delete the folder {{selectedNode.text}}.
              <p class="mt-2">Press Confirm to delete or Cancel to return to the folder.</p>
              <b-button @click="closeDeleteFolderModal" style="margin-right:15px;">Cancel</b-button>
              <b-button type="submit" variant="primary">Confirm</b-button>
          </form>
      </b-modal>

      <b-modal id="mass-delete-modal" hide-header hide-footer>
          <h2>Delete Files</h2>
          <hr/>
          <form ref="form" @submit.prevent="deleteFolderFiles">
              You are about to delete
              <span v-if="selected.length > 0">{{selected.length}} files : <br/>
                <span v-for="(item, index) in selected" :key="index">{{item.filename}}<br/></span>
              </span>
              <span v-if="selected.length === 0">all files from this folder</span>
              <p class="mt-2">Press Confirm to delete or Cancel to return to the folder.</p>
              <div>
                  <b-button @click="closeMassDeleteModal" style="margin-right:15px;">Cancel</b-button>
                  <b-button type="submit" variant="primary">Confirm</b-button>
              </div>
          </form>
      </b-modal>
      <b-modal id="delete-modal" hide-header hide-footer>
          <h2>Delete File</h2>
          <hr/>
          <form ref="form" @submit.prevent="deleteObject(selectedFile)">
              You are about to delete {{selectedFile.filename}}
              <p class="mt-2">Press Confirm to delete or Cancel to return to the folder.</p>
              <div>
                  <b-button @click="closeDeleteModal" style="margin-right:15px;">Cancel</b-button>
                  <b-button type="submit" variant="primary">Confirm</b-button>
              </div>
          </form>
      </b-modal>
  </b-container>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import {eventBus} from '@/main'
import LiquorTree from 'liquor-tree'
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import * as FileSaver from 'file-saver';
import JSZip from "jszip";
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from "vuelidate";

export default {
    
  name: 'fileList',

  mixins: [validationMixin],

  components: {
    [LiquorTree.name]: LiquorTree,
     Splitpanes, 
     Pane 
  },

  data: () => ({
    isLoading: false,
    tagsLoading: false,
    folders:  [],
    selectedNode: {},
    files: [],
    permissions: {},
    selectedFile: {},
    fields: [
            {key: 'select', label: 'Select'},
            {key: 'filename', sortable: true, label: 'File Name'},
            {key: 'lastModified', sortable: true, label: 'Last Modified'},
            {key: 'formattedFileSize', sortable: true, label: 'Size'},
            {key: 'actions', label: 'Actions'}
        ],  
    treeOptions: {
      minFetchDelay: 1000,
    },
    jobType: '01',    //01-Standard, 02-Medical 
    language: 'en-US',
    medicalAudioType: '', //01-Conversation, 02-Dictation
    audioIdentification: false, 
    audioIdentificationType: '',  //01-Channel, 02-Speaker
    maxSpeakerNbr: 2,

    languageOpts: [
      { value: 'en-US', text: 'English (US)' },
    ],
    folderName: "",
    selected: [],
    hasChildFolders: false,
    unfiltered: [],
    keyOpts: [],
    valueOpts: [],
    search: {
        key: [],
        value: [],
        isAnd: false,
    }
  }),

  props: {
    bucketName: {
      type: String,
      required: true,
    },
    bucketType: {
      type: String,
      required: true,
    },
    bucketId: {
      type: String,
      required: true,
    }
  },
  
  created () {
    eventBus.$on('upload-complete', (_bucketName) => {
      this.bucketName = _bucketName
      this.initialize()
    })

    this.initialize()
  },

  computed: {
    currentFolder() {
      if (this.selectedNode.data) {
        return this.selectedNode.data.prefix;
      } else {
        return "/"
      }
    }
  },
  
  methods: {
    initialize() {
      this.isLoading = true
      this.fetchPermissions()
      this.fetchBucketFolders()
      this.fetchBucketFiles()
    },

    deleteFolderFiles() {
      let payload = {
          bucketName: this.bucketName,
          objectNames: []
      };
      if (this.selected.length > 0) {
          this.selected.forEach(file => {
              payload.objectNames.push(file.name)
          })
      } else {
          this.files.forEach(file => {
              payload.objectNames.push(file.name)
          })
      }
      axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'delete/file/multi', payload)
          .then((res) => {
              this.initialize()
          })
          .catch((err) => {
              console.log(err)
          })

      let eventPayload = {
          bucketId: this.bucketId,
          fileNames: payload.objectNames,
          operation: 'delete'
      }
      axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'event', eventPayload)
          .catch((err) => {
              console.log(err)
          })

      this.closeMassDeleteModal()
    },

    deleteObject(item) {
      let payload = {
          bucketName: this.bucketName,
          objectName: item.name
        }

        axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'delete/file', payload)
         .then((res) => {
                  this.initialize()
          })
          .catch((err) => {
              console.log(err)
        })
        let eventPayload = {
            bucketId: this.bucketId,
            fileNames: item.name,
            operation: 'delete'
        }
        axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'event', eventPayload)
            .catch((err) => {
                console.log(err)
            })

        this.closeDeleteModal()
    },
      
      getFolderFileList(node) {
        if(node.data.prefix === undefined) {
            node.data.prefix = ""
        }
        this.selectedNode = node
        eventBus.$emit('folder-selected', this.selectedNode)
        this.fetchBucketFiles(node.data.prefix)
      },
      
      fetchBucketFiles(prefix) {
        let payload = {
          bucketName: this.bucketName,
          objectPrefix: prefix
        }
          
        axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'getBucketFileList', payload)
          .then((res) => {
              this.files = res.data.files
              this.isLoading = false
              this.hasChildFolders = res.data.hasChildFolders
              this.fetchFileTags()
          })
          .catch((err) => {
              console.log(err)            
          })
      },

      fetchBucketFolders() {
        let payload = {
          bucketName: this.bucketName,
        }
        
        axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'getBucketFolderList', payload)
          .then((res) => {
              this.folders = res.data.folders
              this.$refs.folderTree.setModel(this.folders)
          })
          .catch((err) => {
              console.log(err)            
          })
      },

      fetchPermissions() {
        let payload = {
          bucketName: this.bucketId,
        }
        
        axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'getBucketPermissions', payload)
          .then((res) => {
              this.permissions = res.data
          })
          .catch((err) => {
              console.log(err)            
          })
      },

      download(file) {
      },

      editTags(file) {
        this.selectedFile = file
        this.$bvModal.show('modal-tags')
      },

      resize() {
      },

      startTranscribeJob(file) {
        this.selectedFile = file
        this.$bvModal.show('prepare-job-modal')
      },

      showTagModal(file) {
          this.selectedFile = file
          this.$bvModal.show('modal-tags')
      },

      closeTagModal() {
        this.$bvModal.hide('modal-tags')  
      },

      fetchFileTags() {
        this.tagsLoading = true
        this.valueOpts = []
        this.keyOpts = []
        if (typeof this.files !== 'undefined' && this.files !== null && this.files.length > 0) {
            axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'getTags',
                this.files)
                .then((res) => {
                    const data = res.data
                    this.files.forEach(f => {
                        const tag =  res.data.find(d => d.name === f.name).tags
                        f.tags = tag != null ? tag : []
                    })
                    this.tagsLoading = false
                    this.unfiltered = this.files
                    this.files.forEach(f => {
                        f.tags.map(t => {
                            if (this.valueOpts.indexOf(t.value) === -1) {
                                this.valueOpts.push(t.value)
                            }
                            if (this.keyOpts.indexOf(t.key) === -1) {
                                this.keyOpts.push(t.key)
                            }
                        })
                    })
                })
                .catch((err) => {
                    console.log(err)
                })
        }
      },

      showTagSearchModal() {
          this.$bvModal.show('modal-tags-search')
      },

      closeTagSearchModal() {
          this.$bvModal.hide('modal-tags-search')
      },

      searchTags() {
        var keyfiles = []
        var valuefiles = []
        if (this.search.key.length > 0) {
            keyfiles = this.unfiltered.filter(f => this.search.key.some(r => f.tags.map(t => t.key).includes(r)))
        }
        if (this.search.value.length > 0) {
            valuefiles = this.unfiltered.filter(f => this.search.value.some(r=> f.tags.map(t => t.value).includes(r)))
        }
        if (this.search.isAnd) {
            this.files = keyfiles.filter(k => valuefiles.includes(k))
        } else {
            this.files = keyfiles.concat(valuefiles)
        }
        this.closeTagSearchModal()
      },

      clearSearch() {
        this.files = this.unfiltered
        this.search.key = []
        this.search.value = []
        this.search.isAnd = false
        this.closeTagSearchModal()
      },

      closeJobModal() {
        this.$bvModal.hide('prepare-job-modal')  
      },

      saveTags() {
        axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'updateTags', 
          this.selectedFile)
          .then((res) => {
              this.closeTagModal()
              this.fetchFileTags()
          })
          .catch((err) => {
              console.log(err)            
          })
      },

      addTag() {
        this.selectedFile.tags.push({key: null, value: null})
      },

      removeTag(index) {
          this.selectedFile.tags.splice(index, 1)
      },

      submitJob() {
          let payload = {
              bucketId: this.bucketId,
              bucketName: this.bucketName, 
              objectName: this.selectedFile.name,
              jobType: this.jobType,
              language: this.language,
              medicalAudioType: this.medicalAudioType,
              audioIdentification: this.audioIdentification,
              audioIdentificationType: this.audioIdentificationType,
              maxSpeakerNbr: this.maxSpeakerNbr
          }

          axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'transcribe/voice', 
          payload)
          .then((res) => {
              eventBus.$emit('job-refresh')
              this.closeJobModal()
              this.$bvToast.toast('Check the "Audio Transcribe Jobs" tab for progress and results.', {
                title: 'Transcribe Job Submitted',
                toaster: 'b-toaster-top-center',
                solid: true,
                variant: 'success',
                appendToast: true
              }) 
          })
          .catch((err) => {
              console.log(err)            
          })
      },

      showFolderModal() {
          this.$bvModal.show('folder-modal')
      },

      closeFolderModal() {
          this.$bvModal.hide('folder-modal')
      },

      showDeleteFolderModal() {
          this.$bvModal.show('folder-delete-modal')
      },

      closeDeleteFolderModal() {
          this.$bvModal.hide('folder-delete-modal')
      },

      showMassDeleteModal() {
          this.$bvModal.show('mass-delete-modal')
      },

      closeMassDeleteModal() {
          this.$bvModal.hide('mass-delete-modal')
      },

      showDeleteModal(item) {
        this.selectedFile = item
          console.log(item)
        this.$bvModal.show('delete-modal')
      },

      closeDeleteModal() {
        this.$bvModal.hide('delete-modal')
      },

      saveFolder() {
        var prefix = ""
        if (this.selectedNode.data !== undefined) {
            prefix = this.selectedNode.data.prefix
        }
        let payload = {
            bucketName: this.bucketName,
            parentPrefix: prefix,
            folderName: this.folderName,
        }

        axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'folder', payload)
            .then((response) => {
                eventBus.$emit('add-folder')
                this.closeFolderModal()
                this.$bvToast.toast('New Folder ' + this.folderName+ ' Added.', {
                    title: 'Folder Added',
                    toaster: 'b-toaster-top-center',
                    solid: true,
                    variant: 'success',
                    appendToast: true
                })
                this.folderName= ""
                this.fetchBucketFolders()
            })
            .catch((err) => {
                console.log(err)
            })
      },

      deleteFolder() {
          var prefix = ""
          if (this.selectedNode.data !== undefined) {
              prefix = this.selectedNode.data.prefix
              this.selectedNode = {}
          }
          let payload = {
              bucketName: this.bucketName,
              parentPrefix: prefix,
          }
          axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'folder/delete', payload)
              .then((response) => {
                  this.closeDeleteFolderModal()
                  this.$bvToast.toast('Folder ' + this.selectedNode.text + ' Deleted.', {
                      title: 'Folder Deleted',
                      toaster: 'b-toaster-top-center',
                      solid: true,
                      variant: 'success',
                      appendToast: true
                  })
                  this.folderName= ""
                  this.hasChildFolders = true
                  this.fetchBucketFolders()
              })
              .catch((err) => {
                  console.log(err)
              })
      },
      onRowSelected(items) {
          this.selected = items
      },
      downloadEvent(filename) {
          let payload = {
              bucketId: this.bucketId,
              fileNames: filename,
              operation: 'download'
          }
          axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'event', payload)
              .catch((err) => {
                  console.log(err)
              })
      },
      downloadFolderFilesZip() {
          const zip = new JSZip();
          const cache = {};
          const promises = [];
          const filenames = [];
          if(this.selected.length >0) {
              this.selected.forEach(dl => {
                  filenames.push(dl.filename)
                  const promise = axios.get(dl.url, {
                      ignoreHeader: true,
                      responseType: 'arraybuffer'
                  }).then(data => {
                      zip.file(dl.filename, data.data, {binary: true})
                      cache[dl.filename] = data.data
                  }).catch((err) => {
                      console.log(err)
                  })
                  promises.push(promise);
              })
          } else {
              this.files.forEach(dl => {
                  filenames.push(dl.filename)
                  const promise = axios.get(dl.url, {
                      ignoreHeader: true,
                      responseType: 'arraybuffer'
                  }).then(data => {
                      zip.file(dl.filename, data.data, {binary: true})
                      cache[dl.filename] = data.data
                  }).catch((err) => {
                      console.log(err)
                  })
                  promises.push(promise);
              })
          }
          Promise.all(promises).then(() => {
              zip.generateAsync({ type: "blob" }).then(content => {
                  FileSaver.saveAs(content, this.bucketName + ".zip");
              });
          });
          let payload = {
              bucketId: this.bucketId,
              fileNames: filenames,
              operation: 'download'
          }
          axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'event', payload)
              .catch((err) => {
                  console.log(err)
              })
      },
      downloadFolderFiles(){
        const filenames = []
        if(this.selected.length >0) {
            this.selected.forEach(dl => {
                filenames.push(dl.filename)
                axios.get(dl.url, {
                    ignoreHeader: true,
                    responseType: 'arraybuffer'
                }).then(data => {
                    const contentType = data.headers["content-type"];
                    const blob = this.convertToBlob(data.data, contentType)
                    FileSaver.saveAs(blob, dl.filename);
                }).catch((err) => {
                    console.log(err)
                })
            })
        } else {
            this.files.forEach(dl => {
                filenames.push(dl.filename)
                axios.get(dl.url, {
                    ignoreHeader: true,
                    responseType: 'arraybuffer'
                }).then(data => {
                    const contentType = data.headers["content-type"];
                    const blob = this.convertToBlob(data.data, contentType)
                    FileSaver.saveAs(blob, dl.filename);
                }).catch((err) => {
                    console.log(err)
                })
            })
        }
        let payload = {
            bucketId: this.bucketId,
            fileNames: filenames,
            operation: 'download'
        }
        axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'event', payload)
            .catch((err) => {
                console.log(err)
            })
      },
      convertToBlob(data, contentType) {
          const base64String = new Buffer(data, contentType).toString('base64')
          const byteString = atob(base64String);
          const arrayBuffer = new ArrayBuffer(byteString.length);
          const int8Array = new Uint8Array(arrayBuffer);
          for (let i = 0; i < byteString.length; i++) {
              int8Array[i] = byteString.charCodeAt(i);
          }
          const blob = new Blob([int8Array], {type: contentType});
          return blob
      },
      isAdminOrBucketAdmin() {
          return this.$keycloak.hasResourceRole('admin') || this.$keycloak.hasResourceRole('bucket-admin')
      },
  },
  validations: {
      selectedFile: {
          tags: {
              $each: {
                  key: {required,},
                  value: {required},
              }
          }
      }
  },
}
</script>

<style lang="stylus">
primaryBlue = #3498db

#fileTable {
    height: 7em;
}

form.dropzone
  transition all 0.2s linear
  border 2px dashed #ccc
  background-color #fafafa
  min-height initial
  &:hover
    border-color primaryBlue
    background-color white
    .dz-message
      .dropzone-title
        color primaryBlue
  .dz-message
    color #666
    span
      line-height 1.8
      font-size 13px
      letter-spacing 0.4px
      span.dropzone-title
        display block
        color #888
        font-size 1.25em
      span.dropzone-info
        display block
        color #a8a8a8
</style>